import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_layout-private/account-management/sub-account/",
)({
	component: () => (
		<div>Hello /_layout-private/account-management/sub-account/!</div>
	),
});
